<template>
  <div
    v-if="message"
    class="subscriber-toast"
    :data-state="state"
    role="status"
    aria-live="polite"
  >
    <span class="subscriber-toast__message">{{ message }}</span>
    <button
      class="subscriber-toast__close"
      type="button"
      aria-label="Dismiss notification"
      @click="dismiss"
    >
      <XMarkIcon />
    </button>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from "vue";

import XMarkIcon from "@/icons/heroicons/x-mark-micro.svg";

const TOAST_DURATION_MS = 4000;
const TOAST_EXIT_DURATION_MS = 180;

const props = defineProps<{
  flash: { message: string } | null;
}>();

const message = ref<string | null>(null);
const state = ref<"open" | "closing">("open");
let closeTimer: number | null = null;
let removeTimer: number | null = null;

const clearTimers = () => {
  if (closeTimer) {
    window.clearTimeout(closeTimer);
    closeTimer = null;
  }

  if (removeTimer) {
    window.clearTimeout(removeTimer);
    removeTimer = null;
  }
};

const dismiss = () => {
  if (!message.value || state.value === "closing") {
    return;
  }

  state.value = "closing";
  removeTimer = window.setTimeout(() => {
    message.value = null;
  }, TOAST_EXIT_DURATION_MS);
};

watch(
  () => props.flash?.message,
  (nextMessage) => {
    clearTimers();

    if (!nextMessage) {
      dismiss();
      return;
    }

    message.value = nextMessage;
    state.value = "open";
    closeTimer = window.setTimeout(dismiss, TOAST_DURATION_MS);
  },
  { immediate: true }
);

onBeforeUnmount(clearTimers);
</script>
